import { render, staticRenderFns } from "./ChangeComment.vue?vue&type=template&id=f41f77da&"
import script from "./ChangeComment.vue?vue&type=script&lang=js&"
export * from "./ChangeComment.vue?vue&type=script&lang=js&"
import style0 from "./ChangeComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports